import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export default ({
  height = 24,
  width = 24,
  fill = 'currentColor',
  stroke = '#1D222F',
  viewBox = '0 0 24 24'
}) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={viewBox}
    >
      <path
        d="M8.7891 4.5H22.3099C23.2395 4.5 24 5.2875 24 6.25001V22.0001L20.6198 18.5001H8.7891C7.85954 18.5001 7.099 17.7126 7.099 16.75V6.25001C7.099 5.2875 7.85954 4.5 8.7891 4.5Z"
        fill={fill}
      />
      <path
        d="M0.5 18.5001V19.7006L1.35218 18.855L4.73314 15.5001H16.8723C18.1147 15.5001 19.1358 14.4923 19.1358 13.25V2.75001C19.1358 1.50772 18.1147 0.5 16.8723 0.5H2.76358C1.52112 0.5 0.5 1.50772 0.5 2.75001V18.5001Z"
        fill={fill}
        stroke={stroke}
      />
    </SvgIcon>
  );
};
